/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EarnSerialVerifyResponse
 */
export interface EarnSerialVerifyResponse {
    /**
     * The vendor confirmed a registration for this serial. False = not found at the vendor; the client renders its "have you registered?" guidance.
     * @type {boolean}
     * @memberof EarnSerialVerifyResponse
     */
    verified: boolean;
    /**
     * This serial was already claimed for this objective (by this user or another).
     * @type {boolean}
     * @memberof EarnSerialVerifyResponse
     */
    alreadyClaimed: boolean;
    /**
     * 
     * @type {string}
     * @memberof EarnSerialVerifyResponse
     */
    productName?: string;
}

/**
 * Check if a given object implements the EarnSerialVerifyResponse interface.
 */
export function instanceOfEarnSerialVerifyResponse(value: object): value is EarnSerialVerifyResponse {
    if (!('verified' in value) || value['verified'] === undefined) return false;
    if (!('alreadyClaimed' in value) || value['alreadyClaimed'] === undefined) return false;
    return true;
}

export function EarnSerialVerifyResponseFromJSON(json: any): EarnSerialVerifyResponse {
    return EarnSerialVerifyResponseFromJSONTyped(json, false);
}

export function EarnSerialVerifyResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): EarnSerialVerifyResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'verified': json['verified'],
        'alreadyClaimed': json['alreadyClaimed'],
        'productName': json['productName'] == null ? undefined : json['productName'],
    };
}

export function EarnSerialVerifyResponseToJSON(json: any): EarnSerialVerifyResponse {
    return EarnSerialVerifyResponseToJSONTyped(json, false);
}

export function EarnSerialVerifyResponseToJSONTyped(value?: EarnSerialVerifyResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'verified': value['verified'],
        'alreadyClaimed': value['alreadyClaimed'],
        'productName': value['productName'],
    };
}

